import React, { useState, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import {
  seleccionarCampo,
  formatMoneda,
  validaMonto,
  round,
  formatoMonto,
} from "../../util/varios";
import * as XLSX from 'xlsx';
import useTableScroll from "../useTableScroll";

export const ActualizarProductosExcel = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");

  const txtCosto = useRef([]);
  const txtPrecio = useRef([]);
  const btnIncluir = useRef();
  const btnCancela = useRef();
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [activate, setActivate] = useState(false);
  const [jsonData, setJsonData] = useState([]);
  const [productosData, setProductosData] = useState([]);
  const [file, setFile] = useState(null);
  const [body, setBody] = useState(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "CODIGO", textAlign: "center", width: "0px" },
    { label: "DESCRIPCION", textAlign: "center" },
    { label: "COSTO", textAlign: "center" },
    { label: "PRECIO", textAlign: "center" },
    {
      label: <i className="fas fa-trash" />,
      textAlign: "center",
      width: "20px",
    },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);


  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/inventario/actualizarpreciosexcel/`;

    axios.post(endpoint, body, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json"
      }
    })
      .then(function (response) {
        if (response.status === 200) {
          setJsonData([]);
          setMensaje({
            mostrar: true,
            titulo: "Éxito",
            texto: `${response.data.registros_actualizados} registro(s) modificado(s) correctamente`,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        let errorMsg = error.message;
        if (error.response) {
          errorMsg = error.response.data.message || error.response.statusText;
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: `Error al procesar: ${errorMsg}`,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const validarCosto = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let data = [...jsonData];
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      let canti = parseFloat(
        event.target.value.replace(/\./g, "").replace(",", ".")
      );

      data[index].costoproveedor = canti;
      setJsonData(data);
    }
  };

  const validarPrecio = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let data = [...jsonData];
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      let canti = parseFloat(
        event.target.value.replace(/\./g, "").replace(",", ".")
      );

      data[index].preciomaxi = canti;
      setJsonData(data);
    }
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    let data = [...jsonData];
    let elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.codigo !== data[i].codigo) {
        elementos.push(data[i]);
      }
    }
    setJsonData(elementos);
  };

  const onChangeValidar = () => {
    let productos = [];
    for (let i = 0; i < jsonData.length; i++) {

      const costo = parseFloat(jsonData[i].costoproveedor);
      const precio = parseFloat(jsonData[i].preciomaxi);
      // El factor de la unidad alterna ahora se trae de la base de datos
      // (campo valorfactor) y ya no del archivo Excel.
      const valorfactor = parseFloat(jsonData[i].valorfactor) || 1;
      const utilidad = costo > 0 ? round(((precio - costo) / costo) * 100) : 0;

      if (valorfactor > 1) {
        productos.push({
          codigo: jsonData[i].codigo,
          costoproveedor: costo,
          costoproveedoralter: round(costo / valorfactor),
          preciomaxi: precio,
          preciomaxialter: round(precio / valorfactor),
          utipreciomaxi: utilidad,
          utipreciomaxialter: utilidad
        });
      } else {
        productos.push({
          codigo: jsonData[i].codigo,
          costoproveedor: costo,
          costoproveedoralter: costo,
          preciomaxi: precio,
          preciomaxialter: precio,
          utipreciomaxi: utilidad,
          utipreciomaxialter: utilidad
        });
      }

    }
    setBody({ datos_actualizacion: productos });
    if (productos.length > 0) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta Seguro de Modificar el Precio de estos Productos?",
        icono: "confirmacion",
      });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "No hay Productos Incluidos para Actualizar Precios",
        icono: "error",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setActivate(false);
    setHabilitadoBot(true);
    setJsonData([]);
    setBody(null);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setHabilitadoBot(false);
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      const selectedFile = '';
      setFile(selectedFile);
      blanquear();
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHide();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const esNumeroValido = (valor) => {
    // Si es un string vacío o solo espacios, no es un número
    if (typeof valor === "string" && valor.trim() === "") return false;

    return !isNaN(parseFloat(valor)) && isFinite(valor);
  };

  const seleccionarRegistrosProductos = async () => {
    // Se trae el valorfactor (y las unidades) de la base de datos para no
    // depender de la unidad alterna cargada en el Excel.
    let campos =
      "idproducto, idunidadmedida, idunidadalterna, codigo, valorfactor, tipofactor";
    let nomtab = "producto";
    let orden = "idproducto";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      });

      if (response.status === 200 && Array.isArray(response.data)) {
        setProductosData(response.data);
        return response.data;
      }

      setProductosData([]);
      return [];
    } catch (error) {
      let errorMsg = error.message;
      if (error.response) {
        errorMsg = error.response.data.message || error.response.statusText;
      }

      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: `Error al consultar los productos: ${errorMsg}`,
        icono: "error",
      });
      setProductosData([]);
      return [];
    }
  };

  const convertToJson = async () => {
    if (!file) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Por favor selecciona un archivo Excel.",
        icono: "informacion",
      });
      return;
    }

    setActivate(true);

    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

        // Ya no se lee la columna 'unidadalterna': el factor se obtiene
        // de la consulta de productos (campo valorfactor).
        const jsonResult = XLSX.utils.sheet_to_json(firstSheet, {
          header: ['codigo', 'nombrecorto', 'costoproveedor', 'preciomaxi'],
          range: 1
        });

        const requiredColumns = ['codigo', 'nombrecorto', 'costoproveedor', 'preciomaxi'];
        if (jsonResult.length > 0) {
          const missingColumns = requiredColumns.filter(
            col => !Object.keys(jsonResult[0]).includes(col)
          );

          if (missingColumns.length > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: `Faltan columnas requeridas: ${missingColumns.join(', ')}`,
              icono: "error",
            });
            setActivate(false);
            return;
          }
        }

        // Asegurar que los productos estén cargados. Si por algún motivo
        // aún no se han consultado, se traen en este momento.
        let productos = productosData;
        if (!productos || productos.length === 0) {
          productos = await seleccionarRegistrosProductos();
        }

        // Indexar los productos por código para que la búsqueda sea eficiente
        // incluso con cientos o miles de registros (más de 40 productos).
        const productosPorCodigo = new Map();
        for (let i = 0; i < productos.length; i++) {
          const prod = productos[i];
          if (prod && prod.codigo !== undefined && prod.codigo !== null) {
            productosPorCodigo.set(
              prod.codigo.toString().trim().toUpperCase(),
              prod
            );
          }
        }

        const enrichedData = [];
        const noencontrado = [];

        for (let i = 0; i < jsonResult.length; i++) {
          const codigo =
            jsonResult[i].codigo !== undefined && jsonResult[i].codigo !== null
              ? jsonResult[i].codigo.toString().trim().toUpperCase()
              : "";

          const producto = productosPorCodigo.get(codigo);

          if (producto) {
            enrichedData.push({
              ...jsonResult[i],
              idproducto: producto.idproducto,
              idunidadmedida: producto.idunidadmedida,
              idunidadalterna: producto.idunidadalterna,
              // El valorfactor siempre viene de la base de datos.
              valorfactor: esNumeroValido(producto.valorfactor)
                ? parseFloat(producto.valorfactor)
                : 1,
              tipofactor: producto.tipofactor,
              costoproveedor: esNumeroValido(jsonResult[i].costoproveedor)
                ? jsonResult[i].costoproveedor
                : 0,
              preciomaxi: esNumeroValido(jsonResult[i].preciomaxi)
                ? jsonResult[i].preciomaxi
                : 0,
            });
          } else {
            noencontrado.push(jsonResult[i].codigo);
          }
        }

        setJsonData(enrichedData);
        //console.log(`producto(s) no se encontraron;${noencontrado}`);
        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto:
            `Archivo convertido. ${enrichedData.length} registros listos.` +
            (noencontrado.length > 0
              ? ` ${noencontrado.length} producto(s) no se encontraron en la base de datos.`
              : ""),
          icono: "exito",
        });
      } catch (error) {
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: `Error al procesar el archivo: ${error.message}`,
          icono: "error",
        });
      } finally {
        setActivate(false);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={async () => {
        await seleccionarRegistrosProductos();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>Actualizar Precios </Modal.Title>
        <button
          onClick={cancelar}
          ref={btnCancela}
          className="btn btn-sm text-light"
        >
          <i className="fas fa-share-square"> Salir</i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12 " style={{ margin: 0 }}>
            <div className="row col-md-12 py-2" style={{ margin: 0 }}>
              <div className="col-pd-520">
                <div className="col-md-12 row m-0 mb-2 row m-0">
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    className="col-8"
                    onChange={handleFileChange}
                    style={{ marginBottom: '10px' }}
                  />
                  <button
                    disabled={!habilitadoBot}
                    ref={btnIncluir}
                    onClick={convertToJson}
                    className="btn btn-sm col-4 btn-success rounded-pill"
                    title="Carga la tabla con los productos"
                  >
                    <i className="fas fa-long-arrow-alt-down"> Cargar Excel </i>{" "}
                  </button>
                </div>
              </div>
              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 400,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {jsonData &&
                      jsonData.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            className="bg-light d-flex align-items-between px-0"
                            style={{ maxWidth: "500px" }}
                          >
                            {item.codigo}
                          </TableCell>
                          <TableCell
                            className={`align-middle bg-light text-start p-0 pl-2`}
                          >
                            {item.nombrecorto}
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-90">
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="costo"
                              disabled={!habilitadoBot}
                              defaultValue={formatMoneda(
                                item.costoproveedor
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtCosto.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarCosto(index)}
                              onBlur={validarCosto(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-90">
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="precio"
                              disabled={!habilitadoBot}
                              defaultValue={formatMoneda(
                                item.preciomaxi
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtPrecio.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarPrecio(index)}
                              onBlur={validarPrecio(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "30px" }}
                          >
                            <button
                              disabled={!habilitadoBot}
                              onClick={eliminarProducto(item)}
                              className="btn btn-sm btn-danger"
                            >
                              <i className="fa fa-trash"></i>{" "}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
            </div>
          </div>
          <Dimmer active={activate} inverted>
            <Loader inverted>cargando...</Loader>
          </Dimmer>
          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              mensaje.titulo === "Exito."
                ? blanquear()
                : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                })
            }
          />
          <MensajeSiNo
            mensaje={mensajesino}
            onHideNo={() =>
              setMensajesino({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              })
            }
            onHideSi={handleCloseSi}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12 row mt-3">
          <div className="col-md-12 row m-0">
            <button
              disabled={!habilitadoBot}
              ref={btnIncluir}
              onClick={onBotones(5)}
              className="btn btn-sm col-2 btn-primary rounded-pill"
              title="Actualizar Precios"
            >
              <i className="fas fa-edit"> Actualizar </i>{" "}
            </button>
            <button
              ref={btnCancela}
              disabled={!habilitadoBot}
              onClick={onBotones(6)}
              className="btn btn-sm rounded-pill btn-danger col-2 ml-auto"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/almacen/modalActualizarProductExcel.js